import { ref } from 'vue';
import { Bus, useAside, useTour } from '@orion.ui/orion';
import { Reactive } from '@/utils/decorators';
import BaseSetupService from '@/setup/BaseSetupService';
import OrderDetailsStatusHelper from '@/components/order/details/OrderDetailsStatusHelper.vue';

type Props = SetupProps<typeof TourOrderStatusSetupService.props>;

export default class TourOrderStatusSetupService extends BaseSetupService<Props> {
	static readonly props = {};

	@Reactive private readonly state = {};

	readonly _aside?: OrionAside;

	readonly _tourOrderStatus = ref<OrionTour>();

	constructor (props?: Props, _aside?: OrionAside) {
		super(props);
		this._aside = _aside;
	}

	protected onMounted () {
		super.onMounted();
		useTour('tourOrderStatus', this._tourOrderStatus.value);
	}

	openHelpAside () {
		return {
			callback: () => {
				return new Promise((resolve) => {
					useAside({
						Nested: OrderDetailsStatusHelper,
						size: 'lg',
					});
					setTimeout(() => {
						resolve(true);
					}, 600);
				});
			},
			label: 'Suivant',
		};
	}

	closeAside () {
		return {
			callback: () => {
				return new Promise((resolve) => {
					Bus.emit('OrderDetailsStatusHelperSetupService:close-aside');
					resolve(true);
				});
			},
			label: 'Précédent',
		};
	}

	endTourCallback () {
		Bus.emit('OrderDetailsStatusHelperSetupService:close-aside');
	}
}
